<div class="border" [ngClass]="{ 'error': isError }">
    <div class="header">{{notificationHeader}}</div>
    <div class="message" [innerHTML]="notificationMessage"></div>
</div>